<div class="d-flex flex-column h-100 text-grey">
  <div class="left-title-box">
    <div class="left-title">All Entities</div>
  </div>
  <div class="left-content flex-grow-1">
    <div class="sidenav">
      <a [routerLink]="['/Configurator/Overview']"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact: true}">
        <span class="bi bi-view-list" aria-hidden="true"></span>
        Overview
      </a>
      <a *ngFor="let configEntity of configEntities"
         [routerLink]="['/Configurator', configEntity.name]"
         routerLinkActive="active">
        <span [class]="configEntity.icon" aria-hidden="true"></span>
        {{ configEntity.name }}
      </a>
    </div>
  </div>
</div>